export default __webpack_public_path__ + "static/media/4.e00f8769.jpg";